import type { Doc } from "sharedb/lib/client";

import type { PathType, PdfState, VideoState, WorksheetType } from "../shared/types/worksheet";

// Defaults for PDF viewer
export const DEFAULT_ZOOM = 100;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_NUM_PAGES = 1;

export const getDefaultPdfState = (): PdfState => ({
  zoom: DEFAULT_ZOOM,
  pageNumber: DEFAULT_PAGE_NUMBER,
  totalPages: DEFAULT_NUM_PAGES,
});

export const setPdfStateOnDoc = (
  doc: Doc<WorksheetType>,
  fieldPath: PathType,
  oldState: PdfState | undefined,
  pdfState: Partial<PdfState>,
) => {
  const previousState = oldState || {};

  doc.submitOp([
    {
      p: [...fieldPath, "pdfState"],
      od: previousState,
      oi: { ...previousState, ...pdfState },
    },
  ]);
};

export const clearPdfStateOnDoc = (doc: Doc<WorksheetType>, fieldPath: PathType) => {
  doc.submitOp([
    {
      p: [...fieldPath, "pdfState"],
      od: {},
    },
  ]);
};

export const getDefaultVideoState = (): VideoState => ({
  playing: false,
  currentTimeInSeconds: 0,
  playbackRate: 1,
});

export const setVideoStateOnDoc = (
  doc: Doc<WorksheetType>,
  fieldPath: PathType,
  oldState: VideoState | undefined,
  videoState: Partial<VideoState>,
) => {
  const previousState = oldState || {};

  doc.submitOp([
    {
      p: [...fieldPath, "videoState"],
      od: previousState,
      oi: { ...previousState, ...videoState },
    },
  ]);
};

export const clearVideoStateOnDoc = (doc: Doc<WorksheetType>, fieldPath: PathType) => {
  doc.submitOp([
    {
      p: [...fieldPath, "videoState"],
      od: {},
    },
  ]);
};
